import { render, staticRenderFns } from "./MaquinaInstancia.vue?vue&type=template&id=0f1d3c95&"
import script from "./MaquinaInstancia.vue?vue&type=script&lang=js&"
export * from "./MaquinaInstancia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports